import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { PopupComponent } from './popup.component';
@NgModule({
    imports: [ RouterModule, CommonModule, FormsModule ],
    declarations: [ PopupComponent ],
    exports: [ PopupComponent ]
})

export class PopupModule {}
